import React from 'react';
import Grid from '@mui/material/Grid';
import { useDispatch, useSelector } from 'react-redux';
import FormInputText from '../../../../../common/Forms/FormTextField';
import DropdownFormInput from '../../../../../common/Forms/DropdownForm';
import {
  setSapContract,
  setSapCode,
  setSapNum,
  setSapInstitution,
  setSapGender,
} from '../../../../../../redux/organization/organizationTabs/organizationSap/organizationSapForm/organizationSapSlice';

const SapForm = (props) => {
  const { control, defaultValue, register, errors } = props;
  const dispatch = useDispatch();

  const organizationReferenceData = useSelector(
    (state) => state.organizationReferenceData
  );
  const { sapInstitutionList, genderList } = organizationReferenceData;

  return (
    <>
      <Grid container spacing={2} style={{ marginTop: '0px' }}>
        <Grid item xs={12} sm={2.4}>
          <FormInputText
            name='sapContract'
            type='text'
            control={control}
            errors={!!errors.sapContract}
            helperText={errors?.sapContract?.message}
            label='Sap Contract'
            register={register('sapContract', {
              onChange: (e) => dispatch(setSapContract(e.target.value)),
            })}
          />
        </Grid>
        <Grid item xs={12} sm={2.4}>
          <FormInputText
            name='sapCode'
            type='text'
            control={control}
            errors={!!errors.sapCode}
            helperText={errors?.sapCode?.message}
            label='Sap Code'
            register={register('sapCode', {
              onChange: (e) => dispatch(setSapCode(e.target.value)),
            })}
          />
        </Grid>
        <Grid item xs={12} sm={2.4}>
          <FormInputText
            name='sapNum'
            type='number'
            control={control}
            errors={!!errors.sapNum}
            helperText={errors?.sapNum?.message}
            label='Sap#'
            register={register('sapNum', {
              onChange: (e) => dispatch(setSapNum(e.target.value)),
            })}
          />
        </Grid>
        <Grid item xs={12} sm={2.4}>
          <DropdownFormInput
            name='sapInstitution'
            control={control}
            options={sapInstitutionList}
            defaultId={defaultValue?.sapInstitution}
            label='Sap Institution'
            register={register('sapInstitution', {
              onChange: (e) => dispatch(setSapInstitution(e.target.value)),
            })}
          />
        </Grid>
        <Grid item xs={12} sm={2.4}>
          <DropdownFormInput
            name='sapGender'
            control={control}
            options={genderList}
            defaultId={defaultValue?.sapGender}
            label='Gender'
            register={register('sapGender', {
              onChange: (e) => dispatch(setSapGender(e.target.value)),
            })}
          />
        </Grid>
      </Grid>
    </>
  );
};

export default SapForm;
